import type { RouteRecordRaw } from 'vue-router'
import { assertThat } from '../Guards'
import { Routes } from '../../Constants/Routes.ts'
import RedirectToLegacyPage from '../../Views/RedirectToLegacyPage.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/simulation',
    meta: {
      guards: assertThat().authenticated(),
    },
    children: [
      {
        name: Routes.SIMULATION_VIEW,
        path: ':id(\\d+)',
        component: RedirectToLegacyPage,
        props: (route) => ({ id: Number(route.params.id) }),
        meta: {
          target: '/devis/simulation.php?i={id}&p=devis&index=simulation',
        },
      },
    ],
  },
]

export default routes
